<template>
    <v-container class="ma-4">
      <v-select
        v-model="itemSelected"
        :items="props.items"
        :label="itemSelected? null: label"
        outlined
        dense
        class="max-w-sm"
      />
    </v-container>
    
  </template>
  
<script setup>
import { ref, watch } from 'vue'

const itemSelected = ref('')
const emit = defineEmits(['retrive-input-value'])
const props = defineProps({
                            items: {
                                type: Array,
                                default: () => []
                            },
                            label: {
                                type: String,
                                default: "Select item"
                            }
})

watch(itemSelected, (item) => {
    console.log(itemSelected)
    return emit('retrive-input-value', item)
})

</script>

<style>
.v-field__field {
    flex: 1 0;
    grid-area: field;
    position: relative;
    align-items: flex-start;
    display: flex;
    height: 2em;
    font-size: .9em;
    /* border: 1px solid; */
    margin: 0;
    padding: 0;
}
.v-list-item--variant-text .v-list-item__overlay {
    background: #bfdcc040 !important;
    color:red !important;
}
.v-list-item-title {
    font-size: .8rem;
}
.v-select .v-select__selection-text {
    top: 3px;
    position: absolute;
}
.v-container {
    padding: 1px !important;
    margin: 0;
    overflow: hidden;
}
.v-select__menu-icon {
    display: none;
}
.v-list-item--density-default.v-list-item--one-line {
    min-height: 36px !important;
}
</style>